import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/rushFee/list',
    method: 'post',
    data: data
  });
}
export function reportList(data) {
  return request({
    url: '/pmsservice/api/rushFee/reportList',
    method: 'post',
    data: data
  });
}